import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { StylesProvider } from '@material-ui/core';
import { StyledEngineProvider } from '@mui/material/styles';
import { AppStoreProvider } from './state/app.state';
import AppInit from './state/app.init';

ReactDOM.render(
    <React.StrictMode>
        <StylesProvider injectFirst>
            <StyledEngineProvider injectFirst>
                <>
                    <Router basename={process.env.PUBLIC_URL}>
                        <Switch>
                            <Route path='/info/:pId' render={() => <AppStoreProvider><AppInit><App/></AppInit></AppStoreProvider>}/>
                            <Route path='/project/:pId' render={() => <AppStoreProvider><AppInit><App/></AppInit></AppStoreProvider>}/>
                            <Route path='/' render={() => <AppStoreProvider><AppInit><App/></AppInit></AppStoreProvider>}/>
                        </Switch>
                    </Router>
                </>
            </StyledEngineProvider>
        </StylesProvider>
    </React.StrictMode>,
    document.getElementById('bv-root-element')
);

